import { ApiUrls } from "../types/enums";
import { DEFAULT_CULTURE, DEFAULT_TERMINAL } from "../shared/constants";

export const ExecuteOrder = async ({
  timeoutGuid,
  acceptOddsChanges,
  config,
}: ExecuteOrderPayload): Promise<ExecuteOrderResponse> => {
  const response = await fetch(ApiUrls.EXECUTE_ORDER, {
    method: "POST",
    headers: {
      brandid: config.brandId,
      channelid: config.channelId,
      terminal: config.terminal || DEFAULT_TERMINAL,
      language: config.language || DEFAULT_CULTURE,
      "content-type": "application/json",
      ...(config.userToken
        ? {
            token: config.userToken,
            authorization: `Bearer ${config.userToken}`,
          }
        : {}),
    },
    body: JSON.stringify({
      timeoutGuid,
      acceptOddsChanges,
    }),
  });
  return response.json();
};
